import {helper} from "@/services/Helper";
import store from "@/store";
import Property from "@/entity/Property";
import Coverage from "@/entity/Coverage";
import EngineMethod from "@/entity/EngineMethod";
import Insurer from "@/entity/Insurer";
import Pack from "@/entity/Pack";
import Risk from "@/entity/Risk";
import PackGuarantee from "@/entity/PackGuarantee";
import {auth} from "@/services/Auth";
import PropertyChoice from "@/entity/PropertyChoice";

export function createItemFromType(type: any) {

    const item: any = {
        uuid: helper.generateId(),
        model: type.uuid,
        modelCode: type.code,
        modelId: type.id,
        name: type.name,
        isValid: false,
        parentItem: null,
        pack: null,
        createdAt: new Date(),
        properties: {},
    }

    Object.values(type.properties).forEach((p: any) => {
        const property = createPropertyFromType(p)
        property.itemUuid = item.uuid
        property.itemTypeCode = type.code
        item.properties[p.code] = property
    })
    initItem(item)
    return item
}

export function setItemPropertyValue(item: any, property: string, value: any) {
    for (let prop of Object.values(item.properties) as any[]) {
        if (prop.uuid === property || prop.model.code === property) {
            prop.value = value
        }
    }
}

export function getItemPropertyValue(item: any, property: string) {
    for (let prop of Object.values(item.properties) as any[]) {
        if (prop.uuid === property || prop.model.uuid === property || prop.model.code === property) {
            return prop.value
        }
    }
}

export function initItem(item: any) {
    if (!item.modelCode && typeof item.model?.code === 'string') {
        item.modelCode = item.model?.code
    }
    const model = store.state.contractStore.itemTypes[item.modelCode]
    if (!model) {
        console.warn('itemtype ' + item.modelCode + ' introuvable dans contractStore')
        return
    }
    // Nettoyer les propriétés inconnues
    const existingPropertyCodes: string[] = []
    Object.values(model.properties).forEach((p: any) => {
        existingPropertyCodes.push(p.code)
    })
    const unknowProperties = Object.keys(item.properties).filter(el => !existingPropertyCodes.includes(el));
    if (!helper.empty(unknowProperties)) {
        unknowProperties.forEach((up: any) => { delete item.properties[up] })
    }
    item.state = null
    item.errors = []
    item.calculationKey = null
    // Initialiser la coverage si présente
    if (item.coverage) {
        if (helper.empty(item.coverage.uuid)) {
            item.coverage.uuid = helper.generateId()
        }
        if (typeof item.coverage.pack === 'number') {
            let coverage = new Coverage()
            const pack = store.state.contractStore.packs.find((p: any) => p.id === item.coverage.pack)
            const category = store.state.contractStore.packCategories.find((c: any) => pack.category.uuid === c.uuid)
            const insurer = store.state.contractStore.insurers.find((i: any) => pack.insurer.uuid === i.uuid)
            coverage.label = pack.label
            coverage.premium = item.coverage.premium
            coverage.generateFromPack(pack)
            coverage.insurer = insurer
            coverage.category = category
            item.coverage = coverage
        } else {
            if (helper.empty(item.coverage.label)) {
                const pack = store.state.contractStore.packs.find((p: any) => p.id === item.coverage.pack?.id)
                if (pack) { item.coverage.label = pack.label }
            }
            item.coverage = new Coverage(item.coverage)
        }
    }
}

// Compat — les anciens appelants utilisent encore ce nom
export const addItemFunctions = initItem

export function getItemModel(item: any) {
    return store.state.contractStore.itemTypes[item.modelCode]
}

export function validateItem(item: any) {
    const itemType = store.state.contractStore.itemTypes?.[item.modelCode]
    if (!itemType?.properties) {
        item.isValid = true
        return
    }
    let status = true
    item.errors = item.errors || []
    item.errors.length = 0
    const props = Array.isArray(itemType.properties) ? itemType.properties : Object.values(itemType.properties)
    props.forEach((pm: any) => {
        if (pm.type?.code?.match(/OBJECT/)) return
        if (pm.internal) return
        const visible = getPropertyVisibility(item, pm)
        if (!visible) return
        const value = item.properties[pm.code]
        if (pm.required && helper.empty(value)) {
            status = false
            item.errors.push({message: 'La propriété ' + pm.name + ' est requise', uuid: helper.generateId()})
        }
    })
    item.isValid = status
}

export function checkItemPropertiesVisibilities(item: any) {
    // Noop pour le format mapper — la visibilité est calculée à la volée via getPropertyVisibility
}

export function getPropertyVisibility(item: any, pm: any): boolean {
    const groups = Array.isArray(pm.conditionGroups) ? pm.conditionGroups : Object.values(pm.conditionGroups || {})
    if (groups.length === 0) return true
    let decision: boolean | null = null
    for (const group of groups) {
        let cg = true
        const conditions = Array.isArray(group.conditions) ? group.conditions : Object.values(group.conditions || {})
        for (const condition of conditions) {
            const testCode = condition.testingProperty?.code || condition.propertyCode
            if (!testCode) continue
            const testValue = item.properties[testCode]
            if (testValue !== undefined) {
                const result = eval('"' + testValue + '" ' + condition.operator + ' "' + condition.value + '"')
                cg = cg && result
            }
        }
        decision = decision === null ? cg : decision || cg
    }
    return decision === true
}


export function createPropertyFromType(type: any) {
    // Résoudre le type de donnée si c'est un ID
    const model = {...type}
    if (model.typeCode && (!model.type || typeof model.type === 'number')) {
        const dataType = store.getters['masterStore/getDataType'](model.typeCode)
        if (dataType) {
            model.type = dataType
        }
    }
    const property = {
        uuid: helper.generateId(),
        itemUuid: '',
        itemTypeCode: '',
        model: model,
        modelCode: type.code,
        modelId: type.id,
        datatypeCode: type.typeCode,
        error: '',
        isVisible: false,
        isValid: false,
        value: type.value,
        children: [] as any[],
    }
    addPropertyFunctions(property)
    return property
}

export function addPropertyFunctions(property: any) {

    if (!property.modelCode && !property.code) {
        property.modelCode = property.code
    }
    // if (property.model) {
    //     delete property.model
    // }
    // Object.defineProperty(property, 'model', {
    //     get() {
    //
    //         const itemType = store.state.contractStore.itemTypes[property.itemTypeCode]
    //         const match = itemType.properties.find((p: any) => {
    //             return p.code === property.modelCode
    //         })
    //         const type = store.getters['masterStore/getDataType'](property.datatypeCode)
    //         if (type) {
    //             match.type = type
    //         }
    //         return {...match}
    //
    //         // return getPropertyModel(property.itemTypeCode, property.modelCode, property.datatypeCode)
    //     }
    // })

    // property.model = function () {
    //     const itemType = store.state.contractStore.itemTypes[this.itemTypeCode]
    //     const match = itemType.properties.find((p: any) => {
    //         return p.code === this.modelCode
    //     })
    //     const type = store.getters['masterStore/getDataType'](this.datatypeCode)
    //     return {...match, type: type}
    // }
    property.subItemType = function () {
        // console.log('chercher itemtype  ' + this.value + ' de la propriété ' + this.modelCode + ' de ' + this.itemTypeCode+' son uuid est '+this.model.value)
        const it = store.getters["contractStore/getEntityByProperty"]('itemTypes', this.model.value)
        if (!it) {
            console.warn('itemtype  ' + this.model.value + ' de la propriété ' + this.modelCode + ' de ' + this.itemTypeCode + ' introuvable')
        }
        return it
    }

    property.validate = function () {
        // console.log('validating ' + this.model().name)
        // console.log('here')
        // console.log(this.model.required)
        if (!this.isVisible) {
            // console.log('not visible it ok')
            this.isValid = true
            return
        }
        const model = this.model
        if (!model.required) {
            this.isValid = true
            // console.log('not required it ok')

            return
        }
        this.error = ''
        if (model.required && helper.empty(this.value)) {
            // console.log('la réponse a ' + this.model.name + ' est requise')
            this.error = 'Ce champs est réquis'
            this.isValid = false
        }

        if (model.type && this.modelCode === 'DATE') {
            if (!helper.isValidDate(this.value)) {
                this.error = 'Date invalide'
                this.isValid = false
            }
        }

        if (model.type && model.type.code === 'RADIO') {
            const match = Object.values(model.choices || {}).find((c: any) => {
                return c.code === this.value
            })
            if (!match) {
                this.error = 'Choix ' + this.model.name + ' invalide'
                this.isValid = false
            }
        }
        if (helper.empty(this.error)) {
            this.isValid = true
        } else {
            this.isValid = false
        }
        return this.isValid
    }

}

export function getPropertyModel(itemTypeCode: string, modelCode: string, datatypeCode: string) {
    const itemType = store.state.contractStore.itemTypes[itemTypeCode]
    const match: any = Object.values(itemType.properties).find((p: any) => {
        return p.code === modelCode
    })
    const type = store.getters['masterStore/getDataType'](datatypeCode)
    return {...match, type: type}
}

export function getChildrenByPage(children: any, page: number, size = 3) {
    const totalPages = Math.ceil(children.length / size);
    const safePage = Math.min(Math.max(page, 1), totalPages);
    const start = (safePage - 1) * size;
    const end = start + size;
    return children.slice(start, end);
}

export function validateProperty(property: any) {
    if (!property.isVisible) {
        property.isValid = true
        return
    }
    const model = typeof property.model === 'function' ? property.model() : property.model
    if (!model.required) {
        property.isValid = true
        return
    }
    property.error = ''
    if (model.required && helper.empty(property.value)) {
        // console.log('la réponse a ' + this.model.name + ' est requise')
        property.error = 'Ce champs est réquis'
        property.isValid = false
    }

    if (model.type && property.modelCode === 'DATE') {
        if (!helper.isValidDate(property.value)) {
            property.error = 'Date invalide'
            property.isValid = false
        }
    }

    if (model.type && model.type.code === 'RADIO') {
        const match = Object.values(model.choices || {}).find((c: any) => {
            return c.code === property.value
        })
        if (!match) {
            property.error = 'Choix invalide'
            property.isValid = false
        }
    }
    if (helper.empty(property.error)) {
        property.isValid = true
    } else {
        property.isValid = false
    }
    return property.isValid
}

export function checkPropertyVisibility(property: any) {
    let model = property.model
    if (typeof property.model === 'function') {
        model = property.model()
    }
    const groups = Object.values(model.conditionGroups || {})
    if (groups.length === 0) {
        property.isVisible = true;
        return
    }
    let decision = null
    for (let group of groups as any[]) {
        let cg = true
        const conditions = Object.values(group.conditions || {})
        for (let condition of conditions as any[]) {
            const propUuid = condition.testingProperty?.uuid || condition.property
            const testing: any = getNearUpstreamProperty(property, propUuid)
            if (testing) {
                const result = eval('"' + testing.value + '" ' + condition.operator + ' "' + condition.value + '"')
                cg = cg && result
            }
        }
        decision = decision === null ? cg : decision || cg
    }
    property.isVisible = decision === true
}

export function getNearUpstreamProperty(property: any, uuid: string) {
    const item = store.getters["contractStore/getEntity"]('items', property.itemUuid)
    if (item) {
        // console.log('on checher la property ', uuid, ' dans l"objet ', item.model.name)
        const match = Object.values(item.properties).find((p: any) => {
            return p.model.uuid === uuid
        })
        if (match) {
            return match
        }
    } else {
        // console.log('item ' + property.itemUuid + ' est introuvable')
    }
    return null;
}


export function getAlias(self: any, visited: Set<string> = new Set()) {
    if (!self?.uuid || visited.has(self.uuid)) return ''
    visited.add(self.uuid)
    const itemType = store.state.contractStore.itemTypes?.[self.modelCode]
    // Si l'itemType est configuré pour récupérer son alias depuis son parent
    if (itemType?.aliasFromParent && self.parentItem) {
        const parent = store.getters["contractStore/getEntity"]('items', self.parentItem)
        if (parent) {
            const parentAlias = getAlias(parent, visited)
            if (parentAlias) return parentAlias
        }
    }
    let generated = "";
    if (itemType?.properties) {
        Object.values(itemType.properties).forEach((pm: any) => {
            if (pm.isAlias) {
                if (!pm.type?.code?.match(/OBJECT/)) {
                    const value = self.properties[pm.code]
                    if (!helper.empty(value)) {
                        generated += " " + value;
                    }
                } else {
                    const children = self.properties[pm.code]
                    const firstChild = Array.isArray(children) ? children[0] : children
                    if (firstChild) {
                        const child = store.getters["contractStore/getEntity"]('items', firstChild)
                        if (child) {
                            generated += getAlias(child);
                        }
                    }
                }
            }
        });
    }
    if (helper.empty(generated.trim())) {
        if (!helper.empty(self.name)) {
            generated = self.name
        } else {
            generated = itemType?.name || self.modelCode || ''
        }
    }
    return generated.trim() ?? '';
}

export function getIdentifier(self: any) {
    let identifier = "";
    const itemType = store.state.contractStore.itemTypes?.[self.modelCode]
    if (itemType?.properties) {
        Object.values(itemType.properties).forEach((pm: any) => {
            if (pm.identifier) {
                const value = self.properties[pm.code]
                if (!helper.empty(value)) {
                    identifier = (identifier + ' ' + value)
                }
            }
        });
    }
    if (helper.empty(identifier)) {
        identifier = getAlias(self)
    }
    return identifier;
}

// --- GLOBAL TIMING ---
let timelog: { startTime?: number; lastTime?: number } | null = null

export function logTime(label: string,clear = false,fromStart = true) {

    if(clear){
        timelog = null
    }
    const now = Date.now()
    if (!timelog) {
        timelog = {startTime: now, lastTime: now}
        console.log(`[${label}] start`)
        return
    }

    const deltaSinceLast = now - (timelog.lastTime ?? now)
    const deltaSinceStart = now - (timelog.startTime ?? now)
    let text =`[${label}] +${deltaSinceLast}ms from last`
    if(fromStart){
        text += `, total +${deltaSinceStart}ms from start`
    }
    console.log(text)
    timelog.lastTime = now
}


// export function calculatePremium(
//     occ: any,
//     {
//         insurerRestrictions = null,
//         oldCoverages = [],
//         packRestrictions = [],
//         packCategories = []
//     }
// ) {
//     timelog = null;
//     logTime("Calculating premium...");
//
//     const item = store.getters["contractStore/getEntity"]('items', occ.uuid);
//     if (!item) return;
//
//     item.validate();
//     if (!item.isValid) {
//         console.log("Item not ready");
//         return;
//     }
//
//     const currentCoverage = item.coverage;
//     let assetUuids: string[] = [];
//     if (item.model().className === 'Asset') assetUuids.push(item.uuid);
//     else if (item.model().isPackApplier) assetUuids = getAssetsUuidFromTree(item);
//
//     let method: EngineMethod = item.model().method as any;
//     if (!method) {
//         const obj = store.state.contractStore.items.find((it: any) => it.model()?.uuid === item.model()?.uuid);
//         if (obj) method = obj.model().method;
//     }
//
//     if (!method) {
//         console.log(`No method defined for ${item.model().name}`);
//         return;
//     }
//
//     logTime("Method resolved");
//
//     const coverages: Coverage[] = [];
//     const comparisonResume: any[] = [];
//     const workflows: string[] = [];
//     let asaciRequirements: any = null;
//
//     if (isItemImplementWorkflow(item, 'asaci')) {
//         workflows.push('asaci');
//         asaciRequirements = getRequiredCertificates(item);
//     }
//
//     const insurers: Insurer[] = store.state.mainStore.insurers ?? store.state.contractStore.insurers;
//     const itemsByUuid = new Map<string, any>();
//     assetUuids.forEach(uuid => {
//         const asset = store.getters["contractStore/getEntity"]('items', uuid);
//         if (asset) itemsByUuid.set(uuid, asset);
//     });
//
//     logTime("Assets mapped");
//
//     for (const insurer of insurers) {
//         if (!insurer.active) continue;
//
//         const insurerResume = { label: insurer.label, uuid: insurer.uuid, active: insurer.active, packs: [], errors: [] as any[] };
//
//         if (insurerRestrictions && !insurerRestrictions.includes(insurer.slug) && !insurerRestrictions.includes(insurer.uuid)) {
//             console.log('non autorisé')
//             insurerResume.errors.push({ message: `Assureur ${insurer.label} non autorisé` });
//             continue;
//         }
//
//         if (store.state.contractStore.insurer && store.state.contractStore.insurer.slug !== insurer.slug) {
//             insurerResume.errors.push({ message: `Assureur ${insurer.label} différent de ${store.state.contractStore.insurer.label}` });
//             continue;
//         }
//
//         logTime(`---- START Insurer ${insurer.label}`);
//
//         const engineClass = (window['classes'] as any[]).find(c => c.code === insurer.slug);
//         if (!engineClass) continue;
//
//         const insurerEngine = new engineClass.prototype();
//         insurerEngine.debug = true;
//         insurerEngine.getItem = (uuid: string) => itemsByUuid.get(uuid);
//
//         const rootItems = store.getters['contractStore/requiredItemsAndRoot'] || [];
//         const keys = Object.keys(insurerEngine);
//         rootItems.forEach(root => {
//             keys.forEach(k => {
//                 if (root.model().code === k) {
//                     const data = (window['classes'] as any[]).find(c => c.code === k);
//                     if (!data?.prototype) console.error(`${root.model().code} manquant`);
//                     const proto = new data.prototype(root);
//                     proto.engine = insurerEngine;
//                     insurerEngine[k] = proto;
//                 }
//             });
//         });
//
//         if (typeof insurerEngine[method.code] !== 'function') {
//             insurerResume.errors.push({ message: `Méthode manquante: ${insurer.label} ${method.code}` });
//             comparisonResume.push(insurerResume);
//             continue;
//         }
//
//         const packs = (store.state.contractStore.packs || []).filter(p => p.id === insurer.id);
//         insurer.packs?.forEach(p => {
//             if (!packs.find(pk => pk.id === p.id)) packs.push({ ...p, insurer });
//         });
//
//         for (const pack of packs) {
//             if (!pack.enable) continue;
//             if (packCategories?.length && !packCategories.includes(pack.category.slug.toUpperCase())) continue;
//             if (packRestrictions?.length && !packRestrictions.includes(pack.code.toUpperCase())) continue;
//             if (pack.insurer.uuid !== insurer.uuid) continue;
//
//             const coverage = new Coverage();
//             coverage.generateFromPack(new Pack(pack));
//             coverage.insurer = insurer;
//             coverage.category = store.state.contractStore.packCategories.find(c => c.uuid === pack.category.uuid);
//
//             // Réappliquer anciennes garanties optionnelles
//             const oldCoverage = oldCoverages.find(o => o.pack.id === pack.id);
//             if (oldCoverage) {
//                 oldCoverage.risks.forEach((r: Risk) => {
//                     if (r.isOptional && !coverage.risks.find(cr => cr.guarantee.id === r.guarantee.id)) coverage.risks.push(r);
//                 });
//             }
//
//             // Calcul de la prime
//             assetUuids.forEach(uuid => {
//                 const asset = itemsByUuid.get(uuid);
//                 if (asset) asset.coverage = coverage;
//             });
//
//             let premium = 0;
//             try {
//                 premium = insurerEngine[method.code](item.enginePrototype());
//             } catch (e) { console.log(e); }
//
//             coverage.premium = premium;
//             coverages.push(coverage);
//         }
//
//         comparisonResume.push(insurerResume);
//         logTime(`---- END Insurer ${insurer.label}`);
//     }
//
//     coverages.sort((a, b) => a.premium - b.premium);
//     logTime("Calculation complete");
//
//     return { coverages, resume: comparisonResume, workflows, asaciRequirements };
// }



function getAssetsUuidFromTree(item: any, uuids: any[] = []) {
    Object.values(item.properties).forEach((p: any) => {
        if (p.model?.type?.code?.toUpperCase().includes('OBJECT')) {
            const it = p.subItemType()
            p.children.forEach((childUuid: any) => {
                const child = store.getters["contractStore/getEntity"]('items', childUuid)
                if (it.className === 'Asset') {
                    uuids.push(child.uuid)
                }
                getAssetsUuidFromTree(child, uuids)
            })
        }
    })
    return uuids
}


export function isItemImplementWorkflow(model: any, code: string): any {
    return true
}

export function getRequiredCertificates(item: any) {
    let required: any = {
        green: 0,
        blue: 0,
        yellow: 0
    }
    const asaci = isItemImplementWorkflow(item, 'asaci')
    if (asaci) {
        for (let rule of asaci.rules) {
            let fullfit = true
            for (let condition of rule.conditions) {
                if (condition.property) {
                    let prop = getItemPropertyValue(item, condition.property)
                    if (prop && condition.operator) {
                        switch (condition.operator) {
                            case '==': {
                                fullfit = prop == condition.value;
                                break;
                            }
                            case '!=': {
                                fullfit = prop != condition.value;

                                break;
                            }
                            case '>': {
                                fullfit = parseFloat(prop) > parseFloat(condition.value);

                                break;
                            }
                            case '<': {
                                fullfit = parseFloat(prop) < parseFloat(condition.value);
                                break;
                            }
                        }
                    } else {
                        fullfit = false
                    }
                }
                if (fullfit) {
                    if (required.hasOwnProperty(rule.result)) {
                        required[rule.result] = 1
                        // console.log('necessite une attestation ' + rule.result)
                        return required
                    } else {
                        // console.warn('result ' + rule.result + ' not handled')
                    }
                }
            }
            // console.log(required)
        }
    }
}


export function getPropertyByCode(item, name: string) {
    for (let p of Object.values(item.properties) as any) {
        if (p.model.code.toUpperCase() === name.toUpperCase() || p.model.uuid === name) {
            return p;
        }
    }
    return null;
}

export function getPropertyByUuid(item, uuid: string) {
    for (let p of  Object.values(item.properties) as any) {
        if (p.model.uuid === uuid) {
            return p;
        }
    }
    return null;
}

export function getPropertyByLink(item, name: string) {

    for (let p of Object.values(item.properties) as any[]) {
        if (p.model.link && p.model.link.toUpperCase() === name.toUpperCase()) {
            return p;
        }
    }
    return null;
}


export function formattedValue(self: Property) {
    try {
        if (self.model.type.format === 'DATE') {
            return helper.readable(new Date(self.value as any), ('dmY'))
        }
        if (self.model.type.code === 'AMOUNT' || self.model.type.code === 'NUMBER') {
            return helper.currencyFormat(self.value, false, false)
        }

        if (self.model.type.code === 'NUMBER') {
            return helper.currencyFormat(self.value, false, false)
        }

        if (self.model.type.code === 'RADIO') {
            const choice: PropertyChoice = self.model.choices.find((c: PropertyChoice) => {
                return c.code === self.value
            }) as any
            return choice?.label
        }
        if (self.model.type.code === 'BOOLEAN') {
            return self.value as any === true || self.value === 'true' ? 'Oui' : 'Non'
        }
        if (self.model.type.code === 'PACK') {
            const pack = JSON.parse(self.value as any)
            return self.value as any === true || self.value === 'true' ? 'Oui' : 'Non'
        }
    } catch (e) {
    }
    return !helper.empty(self.value) ? self.value : '-'
}
